<div class="disease-gradient-section container-fluid position-relative py-5">
    <!-- Unified Background Circles for all screens -->
    <div class="background-gradient background-gradient--subtle-circles d-print-none" aria-hidden="true">
        <div class="circle-top-left-transparent"></div>
        <div class="circle-top-transparent"></div>
        <div class="circle-small-left d-none d-lg-block"></div>
        <div class="circle-bottom-left d-none d-lg-block"></div>
        <div class="circle-bottom-transparent d-none d-lg-block"></div>
        <div class="circle-top-right-transparent d-none d-lg-block"></div>
        <div class="circle-small-right d-none d-lg-block"></div>
    </div>

    <div class="container-xxxl py-4">
        <div class="row py-2 justify-content-between d-print-block">
            <div class="col-sm-10 offset-sm-1 col-lg-5 offset-lg-0 pb-5 pb-lg-0 d-flex d-print-block flex-column align-items-start">
                <img class="clinical-logo mb-4 pb-2 d-print-none" [src]="imgPathBase + 'ctg-header-logo-white-new.svg'" alt="ClinicalTrials.gov Logo" />
                <div class="text-white fs-6 fs-lg-18 text-start" [innerHTML]="clinicalTrialArticle.bodyText"></div>
                <a [href]="diseaseSearchUrl" target="_blank" class="btn btn-outline-white fs-18 fw-500 d-inline-block mt-4" [innerHTML]="clinicalTrialButton.title"></a>
            </div>
            <div class="vr d-none d-lg-block p-0 d-print-none"></div>
            <hr class="col-sm-10 offset-sm-1 d-lg-none d-print-none" />
            <div class="col-sm-10 offset-sm-1 col-lg-5 offset-lg-0 pt-5 pt-lg-0 d-flex d-print-block flex-column align-items-start">
                <div class="d-flex flex-nowrap align-items-center mb-3 pb-2 text-white d-print-none">
                    <span class="fs-1 fw-500 me-2 lh-1">GARD</span>
                    <span class="fs-7">Genetic and Rare Diseases <br />Information Center</span>
                </div>
                <div class="text-white fs-6 fs-lg-18 text-start" [innerHTML]="contactArticle.bodyText"></div>
                <a [href]="contactButtonUrl" class="btn btn-outline-white fs-18 fw-500 d-inline-block my-4">
                    {{ contactCenter.linkText }}
                    <i class="icon-gard-arrow-right ms-2"></i>
                </a>
                <div class="text-white fs-6 fs-lg-18" [innerHTML]="contactCenter.bodyText"></div>
            </div>
        </div>
    </div>
</div>
